export default state => state || {}



// WEBPACK FOOTER //
// ../src/reducers/companyRoles.js